import SkillResult from './model';

export default SkillResult;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/SkillResult/index.js